<h5
    class="mb-2 appTooltip"
    appTooltip="{{consts.TOOLTIP_MESSAGE}}"
    tooltipPosition="right"
>
    {{consts.TITLE}}
    <mat-icon svgIcon="hub_info"></mat-icon>
</h5>
<a
    class="goto-mydxc"
    href={{consts.MY_DXC_LINK}}
    target="_blank"
>
    {{consts.MY_DXC_REDIRECT_LABEL}} &#8594;
</a>
<div class="row">
    <div class="col news-banner">
        <ng-container *ngIf="latestNews$ | async as latestNews; else loading">
            <ngb-carousel>
                <ng-template ngbSlide *ngFor="let news of latestNews">
                    <figure>
                        <img src="{{news.imagePath}}">
                        <figcaption>
                            <h4>{{news.title}}</h4>
                            <p [innerHTML]="news.description"></p>
                            <a
                                class="goto"
                                href="{{news.link}}"
                                target="_blank"
                                appInsightsTrack
                                [eventData]=news
                                loc="{{consts.TITLE}}"
                            >
                                {{consts.LABEL_GO_TO_ACTION}} &#8594;
                            </a>
                        </figcaption>
                    </figure>
                </ng-template>
            </ngb-carousel>
        </ng-container>
        <ng-template #loading>
            <div class="loading-spinner">
                <mat-spinner [diameter]="50"></mat-spinner>
            </div>
        </ng-template>
    </div>
</div>
